import { module } from 'angular';

import { CircuitService, default as circuitServiceName } from './circuit.service';

export default module('contact.agent.core.channel-digit.softphone.circuit', [])
  // instanciate services module
  .run([circuitServiceName, () => {}])
  // service
  .service(circuitServiceName, CircuitService).name;
